module.exports = __webpack_public_path__ + "img/w3_trash_delete_light.2c5363ef.png";